<div
  class="button  bg-white dark:bg-black p-2"
>
  <div class="maximum-width flex items-center justify-between gap-6 flex-1">
    <customizable-button
      title="Cancel"
      [outline]="true"
      className="dark:text-gray-500"
      (click)="onCancel()"
      type="button"
    />

    <customizable-button
      title="Submit"
      [loading]="loading"
      [disabled]="disabled"
    />
  </div>
</div>
